import { Field } from 'redux-form';
import React from 'react';
import RenderDatepicker from '../../../../common/components/Form/RenderDatepicker';

export const renderDatePicker = (field) => (
  <Field
    required={field.starred}
    key={field.name}
    disabled={field.disabled}
    name={field.name}
    className={field.className}
    readOnly={field.readOnly}
    component={RenderDatepicker}
    floatingLabelText={field.floatingLabelText}
    type={field.type}
    validate={field.validate}
    timestampOutput={field.timestampOutput}
    isUtc={field.isUtc}
    fullWidth
  />
);
